import { Tooltip } from "@mantine/core";
import {
  IconBrandFortnite,
  IconBrandMinecraft,
  IconDeviceGamepad2,
  IconDeviceMobile,
  IconHexagonLetterR,
  IconQuestionMark,
} from "@tabler/icons-react";

const CAMP_ICONS = {
  cc: IconBrandMinecraft,
  pc: IconDeviceGamepad2,
  fc: IconBrandFortnite,
  rc: IconHexagonLetterR,
  bc: IconDeviceMobile,
};

const CampIcon = ({ camp, size = 24, withTooltip = true }) => {
  const campShortcut = camp.shortcut;
  const name = camp.name.replace("Camp", "");
  if (!campShortcut) return;

  const Icon = CAMP_ICONS[campShortcut] ?? IconQuestionMark;
  const icon = <Icon stroke={1.5} size={size} />;

  if (!withTooltip) return icon;

  return (
    <Tooltip label={name} position="top">
      {icon}
    </Tooltip>
  );
};

export default CampIcon;
